import { Store } from 'redux';
import { injectionContainer } from '~src/commonInfra/utils/injectionContainer';
import { AppState } from './state/AppState';


export const {
  /**
   * Retrieves the global instance of the app redux store. This should only be used from outside
   * React components – within React components, use mapStateToProps/mapDispatchToProps.
   */
  get: getAppStore,
  /** Sets the global instance of the app redux store. This should be called only once in the whole app. */
  set: setAppStore
} = injectionContainer< Store<AppState> | undefined >('app store');